import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 在入口文件中引入(暂时不支持单组件引入的方式):
import wcSwiper from 'wc-swiper'
import 'wc-swiper/style.css'
Vue.use(wcSwiper);



import { Progress, Navbar, TabItem, TabContainer, TabContainerItem, Swipe, SwipeItem, Cell, MessageBox, Header, Loadmore } from 'mint-ui';  //导航栏

Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
Vue.component(Progress.name, Progress);
Vue.component(Navbar.name, Navbar);
Vue.component(TabItem.name, TabItem);
Vue.component(TabContainer.name, TabContainer);
Vue.component(TabContainerItem.name, TabContainerItem)
Vue.component(Cell.name, Cell);
Vue.component(Header.name, Header);
Vue.component(Loadmore.name, Loadmore);
// Vue.component(Indicator.name, Indicator);


Vue.prototype.$messagebox = MessageBox


import { urlSearchObj } from "@/utils/util";

const searchObj = urlSearchObj();
console.log(searchObj);

// 调试模式
if (Number(searchObj.debug) === 1) {
  (function () {
    var script = document.createElement("script");
    script.src = "//cdn.jsdelivr.net/npm/eruda";
    document.body.appendChild(script);
    script.onload = function () {
      eruda.init(); // eslint-disable-line
    };
  })();
}
import 'lib-flexible/flexible'
import 'mint-ui/lib/style.css'
import './assets/css/index.css'


// Vue.use(MessageBox)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
